<app-navbar [showSearchInput]="false"></app-navbar>

<div class="shadow-body">
  <app-data-tables *ngIf="!isLoading && !waiterRolesLoaded" (currentSaleUpdate)="setDataSource($event)" (getCurrentSale)="setCurrentSale($event)" [apiCall]="apiCall" [allColumns]="allColumns" [displayedColumns]="displayedColumns" (deleteSale)="deleteSaleModal($event)"></app-data-tables>
</div>

<app-sale-details-modal (updateReadySale)="updateReadySale($event)" [sale]="currentSale"></app-sale-details-modal>
